var enterprise = {
	el: {
		formEdit: document.querySelector('.form-edit'),
		enterpriseSelect: document.querySelector('.js-toggle-select'),
		hiddenField: document.querySelector('.field--hidden')
	},
	selectValue: function selectValue(el) {
		if (el.value === 'Empresa') {
			this.el.hiddenField.querySelector('select').removeAttribute('disabled');
			this.el.hiddenField.style.display = 'block';
		}
		else {
			this.el.hiddenField.querySelector('select').setAttribute('disabled', '');
			this.el.hiddenField.style.display = 'none';
		}
	},
	events: function events() {
		var _this = this;

		this.el.enterpriseSelect.addEventListener('change', function(e) {
			return _this.selectValue(e.currentTarget);
		});
	},
	init: function init() {
		if (!this.el.enterpriseSelect) return;
		this.events();

		if (this.el.formEdit) this.selectValue(this.el.enterpriseSelect)
	}
};
enterprise.init();